import { observer } from 'mobx-react-lite';
import * as React from 'react';

import DoTestSubmission from './DoTestSubmission';
import { useTestSubmissionStore } from './model/test-submissions.hook';

interface DoTestWithPreviewProps {
  onSubmitSuccess: () => void;
  skill: string;
  trialUserId?: string;
}

export const DoTestWithPreview = observer(
  ({ onSubmitSuccess, skill, trialUserId }: DoTestWithPreviewProps) => {
    const testSubmissionStore = useTestSubmissionStore();
    if (!testSubmissionStore || !testSubmissionStore.initialed) {
      return null;
    }

    return (
      <DoTestSubmission
        type={testSubmissionStore.testType}
        onSubmitSuccess={onSubmitSuccess}
        skill={skill}
        trialUserId={trialUserId}
      />
    );
  }
);
